import { render, staticRenderFns } from "./functionData.vue?vue&type=template&id=20b37eca&scoped=true&"
import script from "./functionData.vue?vue&type=script&lang=js&"
export * from "./functionData.vue?vue&type=script&lang=js&"
import style0 from "./functionData.vue?vue&type=style&index=0&id=20b37eca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20b37eca",
  null
  
)

export default component.exports